import { ProductPlan } from 'utils/productFlow/definitions';

export function hasDifferentProductCodes(arr: ProductPlan[]) {
  if (!Array.isArray(arr) || arr.length === 0) {
    return false;
  }

  const productCodeSet = new Set();

  for (const item of arr) {
    productCodeSet.add(item.productCode);

    if (productCodeSet.size > 1) {
      return true;
    }
  }

  return false;
}
